<template>
  <div>
    <v-row>
      <v-col cols="12" sm="12" md="3" lg="3">
        <v-date v-model="dateStart"></v-date>
      </v-col>
      <v-col cols="12" sm="12" md="3" lg="3">
        <v-date v-model="dateEnd"></v-date>
      </v-col>
      <v-col cols="12" sm="12" md="3" lg="3">
        <v-btn class="mx-3" fab dark color="indigo" @click="Search">
          <v-icon dark>fa fa-search</v-icon>
        </v-btn>
      </v-col>
      <v-col cols="12" sm="12" md="3" lg="3">
        <v-btn class="mx-3" fab dark color="green" @click="Prints">
          <v-icon dark>fa fa-print</v-icon>
        </v-btn>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" sm="12" md="12" lg="12">
        <v-data-table
          :headers="hbillsale"
          :items="dsbillsale.Array"
          class="elevation-1"
        >
          <template v-slot:body.append>
            <tr>
              <td colspan="4" class="text-right">รวม</td>
              <td>{{ dsbillsale.RubberWeightTotal }}</td>
              <td>{{ dsbillsale.RubberPercent }}</td>
              <td>{{ dsbillsale.RubberWeightDry }}</td>
              <td>{{ dsbillsale.BillSalesPriceToday }}</td>
              <td>{{ dsbillsale.BillSalesTotal }}</td>
              <td>{{ dsbillsale.BillSaleReceive }}</td>
              <td>{{ dsbillsale.BillSaleStale }}</td>
            </tr>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
  </div>
</template>
<script>
import axios from "axios";
export default {
  data() {
    return {
      dateEnd: "",
      dateStart: "",
      hbillsale: [
        {
          text: "วันที่",
          align: "left",
          sortable: true,
          value: "BillSalesDate",
        },
        {
          text: "แปลง",
          align: "left",
          sortable: true,
          value: "RubberName",
        },
        {
          text: "หมายเหตุ",
          align: "left",
          sortable: true,
          value: "BillSaleRemark",
        },
        {
          text: "น้ำหนัก - ตระกล้า",
          align: "left",
          sortable: true,
          value: "RubberWeight",
        },
        {
          text: "น้ำหนักรวม",
          align: "left",
          sortable: true,
          value: "RubberWeightTotal",
        },
        {
          text: "%",
          align: "left",
          sortable: true,
          value: "RubberPercent",
        },
        {
          text: "ยางแห้ง",
          align: "left",
          sortable: true,
          value: "RubberWeightDry",
        },
        {
          text: "ราคา",
          align: "left",
          sortable: true,
          value: "BillSalesPriceToday",
        },
        {
          text: "รวมเงิน",
          align: "left",
          sortable: true,
          value: "BillSalesTotal",
        },
        {
          text: "จ่าย",
          align: "left",
          sortable: true,
          value: "BillSaleReceive",
        },
        {
          text: "ค้าง",
          align: "left",
          sortable: true,
          value: "BillSaleStale",
        },
      ],
      dsbillsale: [],
    };
  },
  mounted() {
    this.$nextTick(() => {
      let date = Date.now();
      date = new Date(date);

      let start =
        date.getFullYear() + "-" + (date.getMonth() + 1) + "-" + date.getDate();
      let end =
        date.getFullYear() + "-" + (date.getMonth() + 1) + "-" + date.getDate();
      this.Select(start, end);
    });
  },
  methods: {
    Search() {
      this.Select(this.dateStart, this.dateEnd);
    },
    Select(start, end) {
      axios
        .post("/api/v1/select/SelectDate/billsale", {
          dateStart: start,
          dateEnd: end,
        })
        .then((res) => {
          if (res.status == 200) {
            this.dsbillsale = res.data;
          }
        });
    },
    Prints() {
      if(this.dsbillsale.Array.length <= 0) return;
      axios
        .post("/api/v1/Report/pdf", {
          hdtext : "รายงานรับซื่อ",
          hd: this.hbillsale,
          ite: this.dsbillsale.Array,
          fot: [
            {text:"รวม",cols:5},
            {text:this.dsbillsale.RubberWeightTotal,cols:1},
            {text:this.dsbillsale.RubberPercent,cols:1},
            {text:this.dsbillsale.RubberWeightDry,cols:1},
            {text:this.dsbillsale.BillSalesPriceToday,cols:1},
            {text:this.dsbillsale.BillSalesTotal,cols:1},
            {text:this.dsbillsale.BillSaleReceive,cols:1},
            {text:this.dsbillsale.BillSaleStale,cols:1},
          ]
        })
        .then((res) => {
          if (res.status == 200) {
            this.PrintJs({
              printable: res.data.base64,
              type: "pdf",
              base64: true,
            });
          }
        });
    },
  },
};
</script>
<style></style>
